import { graphql } from 'react-relay';
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import type {
	fetchDraftContentAppearanceQuery$data,
	fetchDraftContentAppearanceQuery$variables,
} from './__generated__/fetchDraftContentAppearanceQuery.graphql.ts';

export const fetchDraftContentAppearance = (contentId: string, useCache: boolean = true) => {
	return queryInterop<
		fetchDraftContentAppearanceQuery$data,
		fetchDraftContentAppearanceQuery$variables
	>({
		query: graphql`
			query fetchDraftContentAppearanceQuery($contentId: ID, $status: [String]) {
				content(id: $contentId, status: $status) {
					nodes {
						id
						appearanceDraft: properties(key: "content-appearance-draft") {
							nodes {
								id
								key
								value
								version {
									number
								}
							}
						}
					}
				}
			}
		`,
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
		variables: {
			contentId,
			status: ['current', 'draft'],
		},
	});
};
